import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

import { PropType } from 'vue';
import { ISearchResultItem } from '@/interfaces/search/ISearchResultItem';
import { useRouter } from 'vue-router';
import { useUtil } from '@/services/util-service';


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchResult',
  props: {
  result: {} as PropType<ISearchResultItem>,
  columnConfig: {} as PropType<Record<string, { displayName: string; visible: boolean }>>,
},
  setup(__props) {

const router = useRouter();

 

const getColumnValue = (result: ISearchResultItem | undefined, dataKey: string): string | number | string [] => {
  if (!result) {
    return "";
  }

  var value = result[dataKey];
  if (dataKey === "length" || dataKey === "width") {
    return value ? `${useUtil().formatNumber(value)} meter` : "";
  }

  // get array values as comma-separated string
  if (Array.isArray(value)) {
    return value.join(", ");
  }

  return value ? value : "";
};

const openDetails = (shipId: string | undefined) => {
  if (!shipId) {
    return;
  }

  router.push({ name: 'Details', params: { shipId: shipId } });
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("tr", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columnConfig, (config, dataKey) => {
      return (_openBlock(), _createElementBlock("td", {
        key: dataKey,
        class: _normalizeClass(["column result-table__column", {'result-table__column--hidden': !config.visible, 'result-table__column--comment': dataKey === 'comments'}]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (openDetails(__props.result.uuid)))
      }, [
        _createElementVNode("span", null, _toDisplayString(getColumnValue(__props.result, dataKey)), 1 /* TEXT */)
      ], 2 /* CLASS */))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}
}

})